@if (!(loadingPriceList$|async) && unitPrice) {
  <div>
    {{unitPrice|currency:price?.currency:currencySymbol}}/<span translate>{{unitName}}</span>
  </div>
}
